import _ from "lodash";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import ClassRoom from "Course/routes/ClassRoom";
import Attendance from "Course/routes/Attendance";
import Journal from "Course/routes/Journal";
import Gradebook from "Gradebook";
import Continuum from "Continuum";
import { CircularRoutes } from "Administrator/routes/Circulars";
import ClassPlanner from "./routes/ClassPlanner";
import Routines from "Teacher/routes/Courses/routes/Course/routes/Routines";
import Projects from "Teacher/routes/Projects";
import RecordOfExperimentalProgrammes from "Course/routes/RecordOfExperimentalProgrammes";
import PracticalActivities from "Course/routes/PracticalActivities";

export default store => ({
  // TODO: change this to :class_id once we replace all references
  // keeping this as :course_id because children still consume
  // params.course_id in some places
  path: "class/:course_id",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "classes" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;

      return component;
    })
  ),
  childRoutes: [
    ClassRoom(store),
    Gradebook(store),
    Attendance(store),
    Journal(store),
    Routines(store),
    Continuum(store),
    ClassPlanner(store),
    Projects(store),
    PracticalActivities(store),
    RecordOfExperimentalProgrammes(store),
    ..._.map(CircularRoutes, comp => comp(store)),
  ],
});
